import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  padding-bottom: 150px;

  @media (max-width: 800px) {
    min-width: auto;
    width: calc(100svw - 30px);
  }
`;

export const Title = styled.h1`
  margin-top: 50px;
  text-align: center;
`;

export const Body = styled.p``;
